import moment from "moment";
import { ObjectSchema } from "yup";
import { ConsultantQualityItemEditorFragment } from "@bonliva-crm/graphql";

export type CommonFormData = {
  date: Date;
  comment?: string;
};

export type UseQualityItemEditorParams<T extends CommonFormData> = {
  country: string;
  consultantId: string;
  itemName: string;
  schema: ObjectSchema<T>;
  getStatusParams: (status: ConsultantQualityItemEditorFragment["Status"]) => Partial<T>;
  onClose: () => void;
};

export function getUtcDate(input?: string | Date) {
  return moment.utc(input).startOf("day").toDate();
}
